import { useCallback, useEffect, useRef, useState } from 'react';

import {
	Box,
	Heading,
	Table,
	TableContainer,
	Tbody,
	Text,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';

import { getAllInmuebles } from '../../services/inmuebles';
import InmuebleTableItem from '../../components/Inmuebles/TablaInmuebles/InmuebleTableItem';
import Layout from '../../components/Layout/Layout';
import FiltroInmuebles from '../../components/Filtros/FiltroInmuebles';

const ListarInmuebles = () => {
	const [inmuebles, setInmuebles] = useState([]);
	// const [inmueblesFiltrados, setInmueblesFiltrados] = useState(inmuebles);
	// const [needReload, setNeedReload] = useState(true);

	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [filtros, setFiltros] = useState({});

	const loaderRef = useRef(null);

	const loadMoreInmuebles = useCallback(
		async (pagina, filtrosABuscar) => {
			if (loading || !hasMore) return;
			setLoading(true);
			try {
				const nuevosInmuebles = await getAllInmuebles(
					pagina,
					25,
					filtrosABuscar,
				);
				if (nuevosInmuebles.length < 10) setHasMore(false);

				setInmuebles(prevInmuebles => [
					...prevInmuebles,
					...nuevosInmuebles,
				]);
				setPage(prevPage => prevPage + 1);
			} catch (error) {
				console.error('Error al cargar más inmuebles:', error);
				setHasMore(false);
			} finally {
				setLoading(false);
			}
		},
		[hasMore, loading],
	);

	const handleFiltros = ({ target }) => {
		const { value } = target;

		const newFilters = {
			...filtros,
			[target.name]: value,
		};

		setFiltros(newFilters);
		setInmuebles([]);
		setPage(1);
		setHasMore(true);
		loadMoreInmuebles(1, newFilters);
	};

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting && hasMore && !loading) {
					loadMoreInmuebles(page, filtros);
				}
			},
			{
				threshold: 1.0,
			},
		);

		const currentLoader = loaderRef.current;
		if (currentLoader) {
			observer.observe(currentLoader);

			return () => {
				if (currentLoader) {
					observer.unobserve(currentLoader);
				}
			};
		}
	}, [hasMore, loading, page, filtros, loadMoreInmuebles]);

	// useEffect(() => {
	// 	const getInmuebles = async () => {
	// 		const auxInmuebles = await getAllInmuebles();
	// 		setInmuebles(auxInmuebles);
	// 		setNeedReload(false);
	// 	};

	// 	needReload && getInmuebles();
	// }, [needReload]);

	return (
		<Layout>
			<Box mb={4}>
				<Heading textAlign='center' color='blue.800'>
					INMUEBLES
				</Heading>
			</Box>

			<FiltroInmuebles setFiltros={handleFiltros} />

			<Box mt={6}>
				<TableContainer
					w='100%'
					border='1px'
					borderColor='blue.400'
					rounded='lg'
					shadow='dark-lg'
					overflowX='auto'
					overflowY='auto'
				>
					<Table
						variant='simple'
						whiteSpace='nowrap'
						size={{ base: 'sm', md: 'md', lg: 'lg' }}
					>
						<Thead bgColor='blue.100'>
							<Tr>
								<Th>Inmueble</Th>
								<Th>Estado</Th>
								<Th>Tipo</Th>
								<Th>Propietario</Th>
								<Th>Responsable</Th>
								<Th>Creación</Th>
								<Th>Modificación</Th>
							</Tr>
						</Thead>
						<Tbody>
							{inmuebles &&
								inmuebles.map(inmueble => {
									return (
										<InmuebleTableItem
											key={inmueble.uuid}
											inmueble={inmueble}
										/>
									);
								})}
						</Tbody>
					</Table>
				</TableContainer>
				<Box ref={loaderRef} height='40px' />
				{loading && (
					<Text textAlign='center' mt={4}>
						Cargando...
					</Text>
				)}
				{!hasMore && (
					<Text textAlign='center' mt={4}>
						No hay más inmuebles para mostrar.
					</Text>
				)}
			</Box>
		</Layout>
	);
};

export default ListarInmuebles;
